import React from "react";
import { Asterisk } from "lucide-react";
import { marqueeItems } from "../mock";

const Marquee = ({ inverted = false }) => {
  const items = [...marqueeItems, ...marqueeItems];
  return (
    <div
      className={`relative overflow-hidden border-y ${
        inverted ? "bg-foreground text-background border-foreground" : "bg-background border-border"
      }`}
      data-testid="marquee"
      aria-hidden="true"
    >
      <div className="marquee-track py-4">
        {items.map((item, i) => (
          // The list is a static string array rendered twice for the loop, so item+pass is a stable key.
          <div key={`${item}-${i < marqueeItems.length ? "a" : "b"}`} className="flex items-center gap-6 pr-6">
            <span className="display text-2xl md:text-3xl uppercase tracking-wide whitespace-nowrap">
              {item}
            </span>
            <Asterisk className={`h-5 w-5 ${inverted ? "text-primary" : "text-primary"}`} strokeWidth={2.5} />
          </div>
        ))}
      </div>
    </div>
  );
};

export default Marquee;
